<script>
  import { Card } from 'attractions'
</script>

<Card outline>
  <div class="api command">addPickupCommand()</div>
  Instructs the robot to pick up a game piece from the playing surface.
  <div sclass="api title">Arguments:</div>
  <ul>
    <li>[none]</li>
  </ul>
  <div class="api title">Constraints:</div>
  <ul>
    <li>[none]</li>
  </ul>
  <div class="api title">Example:</div>
  <div class="api code">
    <pre>
      robot.addPickupCommand();
    </pre>
  </div>
</Card>
